module.exports = __webpack_public_path__ + "static/media/care_hawaii_icon.4f788495.png";